import { render } from "./Headernav.vue?vue&type=template&id=06c7a6d0&scoped=true"
import script from "./Headernav.vue?vue&type=script&lang=js"
export * from "./Headernav.vue?vue&type=script&lang=js"

import "./headernav.scss?vue&type=style&index=0&id=06c7a6d0&lang=scss&scoped=true"

import exportComponent from "/Users/mac/lavide-pro2/lavideo-pages/noka/lwInno.com /node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c7a6d0"]])

export default __exports__